/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const PendingReason = {
    MISSING_BANK_DATA: 'MISSING_BANK_DATA',
    MISSING_GUARANTOR: 'MISSING_GUARANTOR',
    POLICY_REVIEW: 'POLICY_REVIEW',
    INFO_REQUESTED: 'INFO_REQUESTED'
} as const;

export type PendingReason = typeof PendingReason[keyof typeof PendingReason];



